import { useEffect } from "react";
import { Navbar } from "@/components/Navbar";

export const PageShell = ({ children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative min-h-screen bg-[#F8F7F3] text-[#10202E]">
      <div className="noise-overlay" />
      <Navbar />
      <main>{children}</main>
    </div>
  );
};
